import { IMiddlewaresConfig } from 'smarthub-common'
import { fetchMiddleware } from './fetch.middleware'
import { renderMiddleware } from './render.middleware'
import { transformMiddleware } from './transform.middleware'
import { actionMiddleware } from './action.middleware'
import { activityMiddleware } from './activity.middleware'
import { attachmentMiddleware } from './attachment.middleware'

export const middlewares = (): IMiddlewaresConfig => ({
  fetch: fetchMiddleware(),
  transform: transformMiddleware(),
  render: renderMiddleware(),
  attachment: attachmentMiddleware(),
  action: actionMiddleware(),
  activity: activityMiddleware(),
})
